import { FC } from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumb.css';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface ManualBreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: FC<ManualBreadcrumbProps> = ({ items }) => {
  if (!items.length) return null;

  return (
    <nav className="breadcrumb" aria-label="breadcrumb">
      <ol>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className={isLast ? 'active' : ''}>
              {item.path && !isLast ? (
                <Link to={item.path}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;